import { motion } from "framer-motion";
import { Check, Globe, Layout, Zap, Smartphone, Search } from "lucide-react";
import { InteractiveHoverButton } from "./ui/interactive-hover-button";
import { Link } from "react-router-dom";

const WebsiteCreationSection = () => {
  const features = [
    {
      icon: Layout,
      title: "Design Exclusivo",
      desc: "Sites personalizados que refletem a essência da sua marca.",
    },
    {
      icon: Smartphone,
      title: "100% Responsivo",
      desc: "Experiência perfeita em computadores, tablets e smartphones.",
    },
    {
      icon: Zap,
      title: "Alta Velocidade",
      desc: "Páginas leves e rápidas para melhor retenção de usuários.",
    },
    {
      icon: Search,
      title: "Otimizado para SEO",
      desc: "Estrutura preparada para indexação e rankeamento no Google.",
    },
  ];

  const benefits = [
    "Hospedagem de alta performance",
    "Certificado SSL de segurança",
    "Integração com WhatsApp",
    "Painel administrativo intuitivo",
  ];

  return (
    <section className="py-24 bg-background overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-block px-4 py-1.5 mb-6 rounded-full border border-primary/20 bg-primary/5 text-primary text-sm font-bold tracking-wider uppercase">
              Web Design & Desenvolvimento
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-foreground mb-6 leading-tight">
              Criação de <span className="text-primary">Sites Profissionais</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Desenvolvemos sites de alto impacto que não apenas apresentam sua empresa, mas funcionam como uma poderosa ferramenta de vendas 24 horas por dia.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
              {features.map((feature, i) => (
                <div key={i} className="flex gap-4">
                  <div className="mt-1 shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
                    <feature.icon size={20} />
                  </div>
                  <div>
                    <h3 className="font-bold text-foreground mb-1">{feature.title}</h3>
                    <p className="text-sm text-muted-foreground">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="space-y-3 mb-10">
              {benefits.map((benefit, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-emerald-500/10 flex items-center justify-center">
                    <Check size={12} className="text-emerald-500" />
                  </div>
                  <span className="text-muted-foreground font-medium">{benefit}</span>
                </div>
              ))}
            </div>

            <Link to="/contato">
              <InteractiveHoverButton text="SOLICITAR ORÇAMENTO" className="border-[#ffbc00] text-white" />
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-primary/20 blur-3xl rounded-full opacity-30 animate-pulse" />
            <img
              src="/lovable-uploads/cae12f55-2a77-4925-99c3-ba891aa8533c.png"
              alt="Criação de sites profissionais"
              className="relative rounded-2xl shadow-2xl border border-white/10 w-full z-10"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WebsiteCreationSection;
